import { render, staticRenderFns } from "./red.vue?vue&type=template&id=796b3bbc&scoped=true"
import script from "./red.vue?vue&type=script&lang=js"
export * from "./red.vue?vue&type=script&lang=js"
import style0 from "./red.vue?vue&type=style&index=0&id=796b3bbc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796b3bbc",
  null
  
)

export default component.exports